import { metrics, setup } from '@seek/metrics-js';

import { ReleaseVersion } from '../version';

import type { Environment } from './apiInstance';

import type { ApiConfig } from '.';

type Endpoints = {
  [env in Environment]: string;
};

const endpointDomain: Endpoints = {
  local: 'staging.cloud.seek.com.au',
  dev: 'staging.cloud.seek.com.au',
  prod: 'cloud.seek.com.au',
};

const setupMetricTracking = (config: ApiConfig): void => {
  if (!config) {
    throw new Error('Missing config');
  }

  const { environment, country } = config;

  const domain = endpointDomain[environment];

  setup({
    host: `https://rr-metrics-forwarder.${domain}`,
    prefix: 'rr-caja',
    isEnabled: true,
  });

  metrics.addGlobalTags([
    `env:${environment}-au`,
    `country:${country.toLocaleLowerCase()}`,
    `config_authtype:oidc`,
    `hosting_environment:${location.hostname}`,
    `version:${ReleaseVersion}`,
  ]);
};

const trackWidgetInit = (): void => {
  if (performance && typeof performance.now === 'function') {
    metrics.timing('init', performance.now());
  }
  metrics.sendPagePerformance();
};

export { trackWidgetInit, setupMetricTracking };
